<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Detail Daftar Edit Gadai</h5>
            </template>
            <b-form>
                <div class="form-content-wrapper">
                    <h6 class="form-title">DATA ANGGOTA</h6>
                    <div class="detail-data-wrapper mb-4">
                        <b-row class="mb-2">
                            <b-col cols="4" class="detail-data-label">No. Anggota</b-col>
                            <b-col v-if="dataEditGadai.anggota.noAnggota != null"><strong>{{ dataEditGadai.anggota.noAnggota }}</strong></b-col>
                            <b-col v-else>-</b-col>
                        </b-row>
                        <b-row class="mb-2">
                            <b-col cols="4" class="detail-data-label">No. KTP</b-col>
                            <b-col v-if="dataEditGadai.anggota.noIdentitas != null">{{ dataEditGadai.anggota.noIdentitas }}</b-col>
                            <b-col v-else>-</b-col>
                        </b-row>
                        <b-row class="mb-2">
                            <b-col cols="4" class="detail-data-label">Nama</b-col>
                            <b-col v-if="dataEditGadai.anggota.namaAnggota != null">{{ dataEditGadai.anggota.namaAnggota }}</b-col>
                            <b-col v-else>-</b-col>
                        </b-row>
                        <b-row class="mb-2">
                            <b-col cols="4" class="detail-data-label">Alamat</b-col>
                            <b-col v-if="dataEditGadai.anggota.alamat != null">{{ dataEditGadai.anggota.alamat }}</b-col>
                            <b-col v-else>-</b-col>
                        </b-row>
                        <b-row class="mb-2">
                            <b-col cols="4" class="detail-data-label">No. Handphone</b-col>
                            <b-col v-if="dataEditGadai.anggota.noHp != null">{{ dataEditGadai.anggota.noHp }}</b-col>
                            <b-col v-else>-</b-col>
                        </b-row>
                    </div>
                </div>
                <div class="form-content-wrapper">
                    <h6 class="form-title">DATA BARANG</h6>
                    <b-row>
                        <b-col lg="4" md="6" cols="6">
                            <h6 class="compare-text-title">Data Sekarang</h6>
                            <div class="mb-2">
                                <div class="detail-data-label">Jenis Barang</div>
                                <div v-if="dataEditGadai.barangLama.jenis.name != null">{{ dataEditGadai.barangLama.jenis.name }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Merk Barang</div>
                                <div v-if="dataEditGadai.barangLama.merk.name != null">{{ dataEditGadai.barangLama.merk.name }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Tipe Barang</div>
                                <div v-if="dataEditGadai.barangLama.tipe.name != null">{{ dataEditGadai.barangLama.tipe.name }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Kondisi / Grade Barang</div>
                                <div v-if="dataEditGadai.barangLama.gradeKondisi.name != null">{{ dataEditGadai.barangLama.gradeKondisi.name }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">No. IMEI/SN</div>
                                <div v-if="dataEditGadai.barangLama.noImei != null">{{ dataEditGadai.barangLama.noImei }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Warna</div>
                                <div v-if="dataEditGadai.barangLama.warna.name != null">{{ dataEditGadai.barangLama.warna.name }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Kondisi/ Kerusakan/ Keterangan Lainnya</div>
                                <div v-if="dataEditGadai.barangLama.keterangan != null && dataEditGadai.barangLama.keterangan != 'null'">{{ dataEditGadai.barangLama.keterangan }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Kelengkapan Barang</div>
                                <div v-if="dataEditGadai.barangLama.kelengkapan.length != 0">
                                    <ul class="list-circle-wrapper">
                                        <li v-for="item in dataEditGadai.barangLama.kelengkapan"  v-bind:key="item">
                                            {{ item }}
                                        </li>
                                    </ul>
                                </div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Spesifikasi Barang</div>
                                <div v-if="dataEditGadai.barangLama.spesifikasi.length != 0">
                                    <ul class="list-circle-wrapper">
                                        <li v-for="(item, idx) in dataEditGadai.barangLama.spesifikasi"  v-bind:key="idx">
                                            {{ item.name }}
                                        </li>
                                    </ul>
                                </div>
                                <div v-else>-</div>
                            </div>
                        </b-col>
                        <b-col lg="4" md="6" cols="6" class="comparison-separator">
                            <h6 class="compare-text-title">Data Perubahan</h6>
                            <div class="mb-2">
                                <div class="detail-data-label">Jenis Barang</div>
                                <div v-if="dataEditGadai.barangBaru.jenis.name != null">{{ dataEditGadai.barangBaru.jenis.name }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Merk Barang</div>
                                <div v-if="dataEditGadai.barangBaru.merk.name != null">{{ dataEditGadai.barangBaru.merk.name }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Tipe Barang</div>
                                <div v-if="dataEditGadai.barangBaru.tipe.name != null">{{ dataEditGadai.barangBaru.tipe.name }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Kondisi / Grade Barang</div>
                                <div v-if="dataEditGadai.barangBaru.gradeKondisi.name != null">{{ dataEditGadai.barangBaru.gradeKondisi.name }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">No. IMEI/SN</div>
                                <div v-if="dataEditGadai.barangBaru.noImei != null">{{ dataEditGadai.barangBaru.noImei }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Warna</div>
                                <div v-if="dataEditGadai.barangBaru.warna.name != null">{{ dataEditGadai.barangBaru.warna.name }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Kondisi/ Kerusakan/ Keterangan Lainnya</div>
                                <div v-if="dataEditGadai.barangBaru.keterangan != null && dataEditGadai.barangBaru.keterangan != 'null'">{{ dataEditGadai.barangBaru.keterangan }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Kelengkapan Barang</div>
                                <div v-if="dataEditGadai.barangBaru.kelengkapan.length != 0">
                                    <ul class="list-circle-wrapper">
                                        <li v-for="item in dataEditGadai.barangBaru.kelengkapan"  v-bind:key="item">
                                            {{ item }}
                                        </li>
                                    </ul>
                                </div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Spesifikasi Barang</div>
                                <div v-if="dataEditGadai.barangBaru.spesifikasi.length != 0">
                                    <ul class="list-circle-wrapper">
                                        <li v-for="(item, idx) in dataEditGadai.barangBaru.spesifikasi"  v-bind:key="idx">
                                            {{ item.name }}
                                        </li>
                                    </ul>
                                </div>
                                <div v-else>-</div>
                            </div>
                        </b-col>
                    </b-row>
                </div>

                <div v-if="dataEditGadai.barangLama.kendaraan != null" class="detail-data-wrapper mb-4">
                        <h6 class="form-title">DATA STNK</h6>
                        <b-row>
                            <b-col lg="4" md="6" cols="6">
                                <h6 class="compare-text-title">Data Sekarang</h6>
                                <div class="mb-2">
                                    <div class="detail-data-label">STNK Atas Nama</div>
                                    <div v-if="dataEditGadai.barangLama.kendaraan.namaSTNK != null">{{ dataEditGadai.barangLama.kendaraan.namaSTNK }}</div>
                                    <div v-else>-</div>
                                </div>
                                <div class="mb-2">
                                    <div cols="4" class="detail-data-label">Kota STNK</div>
                                    <div v-if="dataEditGadai.barangLama.kendaraan.kotaSTNK != null">{{ dataEditGadai.barangLama.kendaraan.kotaSTNK.name }}</div>
                                    <div v-else>-</div>
                                </div>
                                <div class="mb-2">
                                    <div cols="4" class="detail-data-label">Kecamatan STNK</div>
                                    <div v-if="dataEditGadai.barangLama.kendaraan.kecamatanSTNK != null">{{ dataEditGadai.barangLama.kendaraan.kecamatanSTNK.name }}</div>
                                    <div v-else>-</div>
                                </div>
                                <div class="mb-2">
                                    <div cols="4" class="detail-data-label">Kelurahan STNK</div>
                                    <div v-if="dataEditGadai.barangLama.kendaraan.kelurahanSTNK != null">{{ dataEditGadai.barangLama.kendaraan.kelurahanSTNK.name }}</div>
                                    <div v-else>-</div>
                                </div>
                                <div class="mb-2">
                                    <div cols="4" class="detail-data-label">RT</div>
                                    <div v-if="dataEditGadai.barangLama.kendaraan.rtSTNK != null">{{ $helper.formatThreeDigitNumber(dataEditGadai.barangLama.kendaraan.rtSTNK) }}</div>
                                    <div v-else>-</div>
                                </div>
                                <div class="mb-2">
                                    <div cols="4" class="detail-data-label">RW</div>
                                    <div v-if="dataEditGadai.barangLama.kendaraan.rwSTNK != null">{{ $helper.formatThreeDigitNumber(dataEditGadai.barangLama.kendaraan.rwSTNK) }}</div>
                                    <div v-else>-</div>
                                </div>
                                <div class="mb-2">
                                    <div class="detail-data-label">Alamat STNK</div>
                                    <div v-if="dataEditGadai.barangLama.kendaraan.alamatSTNK != null">{{ dataEditGadai.barangLama.kendaraan.alamatSTNK }}</div>
                                    <div v-else>-</div>              
                                </div>
                                <div class="mb-2">
                                    <div class="detail-data-label">Masa berlaku pajak STNK</div>
                                    <div v-if="dataEditGadai.barangLama.kendaraan.pajakSTNK != null">{{$helper.changeDateFormat(dataEditGadai.barangLama.kendaraan.pajakSTNK) }}</div>
                                    <div v-else>-</div>                        
                                </div>
                            </b-col>
                            <b-col lg="4" md="6" cols="6" class="comparison-separator">
                                <h6 class="compare-text-title">Data Perubahan</h6>
                                <div class="mb-2">
                                    <div class="detail-data-label">STNK Atas Nama</div>
                                    <div v-if="dataEditGadai.barangBaru.kendaraan.namaSTNK != null">{{ dataEditGadai.barangBaru.kendaraan.namaSTNK }}</div>
                                    <div v-else>-</div>
                                </div>
                                <div class="mb-2">
                                    <div cols="4" class="detail-data-label">Kota STNK</div>
                                    <div v-if="dataEditGadai.barangBaru.kendaraan.kotaSTNK != null">{{ dataEditGadai.barangBaru.kendaraan.kotaSTNK.name }}</div>
                                    <div v-else>-</div>
                                </div>
                                <div class="mb-2">
                                    <div cols="4" class="detail-data-label">Kecamatan STNK</div>
                                    <div v-if="dataEditGadai.barangBaru.kendaraan.kecamatanSTNK != null">{{ dataEditGadai.barangBaru.kendaraan.kecamatanSTNK.name }}</div>
                                    <div v-else>-</div>
                                </div>
                                <div class="mb-2">
                                    <div cols="4" class="detail-data-label">Kelurahan STNK</div>
                                    <div v-if="dataEditGadai.barangBaru.kendaraan.kelurahanSTNK != null">{{ dataEditGadai.barangBaru.kendaraan.kelurahanSTNK.name }}</div>
                                    <div v-else>-</div>
                                </div>
                                <div class="mb-2">
                                    <div cols="4" class="detail-data-label">RT</div>
                                    <div v-if="dataEditGadai.barangBaru.kendaraan.rtSTNK != null">{{ $helper.formatThreeDigitNumber(dataEditGadai.barangBaru.kendaraan.rtSTNK) }}</div>
                                    <div v-else>-</div>
                                </div>
                                <div class="mb-2">
                                    <div cols="4" class="detail-data-label">RW</div>
                                    <div v-if="dataEditGadai.barangBaru.kendaraan.rwSTNK != null">{{ $helper.formatThreeDigitNumber(dataEditGadai.barangBaru.kendaraan.rwSTNK) }}</div>
                                    <div v-else>-</div>
                                </div>
                                <div class="mb-2">
                                    <div class="detail-data-label">Alamat STNK</div>
                                    <div v-if="dataEditGadai.barangBaru.kendaraan.alamatSTNK != null">{{ dataEditGadai.barangBaru.kendaraan.alamatSTNK }}</div>
                                    <div v-else>-</div>              
                                </div>
                                <div class="mb-2">
                                    <div class="detail-data-label">Masa berlaku pajak STNK</div>
                                    <div v-if="dataEditGadai.barangBaru.kendaraan.pajakSTNK != null">{{$helper.changeDateFormat(dataEditGadai.barangBaru.kendaraan.pajakSTNK) }}</div>
                                    <div v-else>-</div>                        
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                <div class="form-content-wrapper">
                    <h6 class="form-title">DATA PERHITUNGAN</h6>
                    <b-row>
                        <b-col lg="4" md="6" cols="6">
                            <h6 class="compare-text-title">Data Sekarang</h6>
                            <div class="mb-2">
                                <div class="detail-data-label">Harga Barang</div>
                                <div v-if="dataEditGadai.perhitunganLama.hargaBarang != null">Rp. {{ $helper.addThousandSeparator(dataEditGadai.perhitunganLama.hargaBarang) }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Pinjaman Maksimal</div>
                                <div v-if="dataEditGadai.perhitunganLama.pinjamanMaksimal != null">Rp. {{ $helper.addThousandSeparator(dataEditGadai.perhitunganLama.pinjamanMaksimal) }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Taksiran Harga</div>
                                <div v-if="dataEditGadai.perhitunganLama.taksiranHarga != null">Rp. {{ $helper.addThousandSeparator(dataEditGadai.perhitunganLama.taksiranHarga) }}</div>
                                <div v-else>-</div>
                            </div>
                        </b-col>
                        <b-col lg="4" md="6" cols="6" class="comparison-separator">
                            <h6 class="compare-text-title">
                                Data Perubahan
                                <i class="fa fa-info tooltip-trigger-btn ml-1" id="tooltip-data-perubahan"></i>
                                <b-tooltip target="tooltip-data-perubahan" triggers="hover">
                                    Hitungan Pinjaman Maksimal dan Taksiran Harga tidak menghitung promo dan adjustment status anggota yang didapatkan pada saat penggadaian
                                </b-tooltip>
                            </h6>
                            <div class="mb-2">
                                <div class="detail-data-label">Harga Barang</div>
                                <div v-if="dataEditGadai.perhitunganBaru.hargaBarang != null">Rp. {{ $helper.addThousandSeparator(dataEditGadai.perhitunganBaru.hargaBarang) }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Pinjaman Maksimal</div>
                                <div v-if="dataEditGadai.perhitunganBaru.pinjamanMaksimal != null">Rp. {{ $helper.addThousandSeparator(dataEditGadai.perhitunganBaru.pinjamanMaksimal) }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Taksiran Harga</div>
                                <div v-if="dataEditGadai.perhitunganBaru.taksiranHarga != null">Rp. {{ $helper.addThousandSeparator(dataEditGadai.perhitunganBaru.taksiranHarga) }}</div>
                                <div v-else>-</div>
                            </div>
                        </b-col>
                    </b-row>
                </div>
                <div class="form-content-wrapper">
                    <h6 class="form-title">DATA PENDUKUNG</h6>
                    <b-row>
                        <b-col lg="4" md="6" cols="6">
                            <h6 class="compare-text-title">Data Sekarang</h6>
                            <div class="mb-2">
                                <div class="detail-data-label">Foto</div>
                                <div v-if="$helper.isNotNullAndNotEmpty(dataEditGadai.fotoLama)">
                                    <ModalFoto isButton withLength :photos="dataEditGadai.fotoLama.map(foto => foto.name)" />
                                </div>
                                <div v-else>-</div>
                            </div>
                        </b-col>
                        <b-col lg="4" md="6" cols="6" class="comparison-separator">
                            <h6 class="compare-text-title">Data Perubahan</h6>
                            <div class="mb-2">
                                <div class="detail-data-label">Foto</div>
                                <div v-if="$helper.isNotNullAndNotEmpty(dataEditGadai.fotoBaru)">
                                    <ModalFoto isButton withLength :photos="dataEditGadai.fotoBaru.map(foto => foto.name)" />
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </div>
                <div class="form-content-wrapper">
                    <h6 class="form-title">ALASAN PERUBAHAN</h6>
                    <b-row class="mb-2">
                        <b-col cols="12" md="4" class="detail-data-label">Keterangan</b-col>
                        <b-col v-if="dataEditGadai.keteranganRevisi != null">{{ dataEditGadai.keteranganRevisi }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="12" md="4" class="detail-data-label">Diajukan pada</b-col>
                        <b-col>{{ $helper.changeDateFormat(dataEditGadai.tanggalPengajuan )}} {{ $helper.changeDateFormatGetHour(dataEditGadai.tanggalPengajuan )}}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="12" md="4" class="detail-data-label">Diajukan oleh</b-col>
                        <b-col>{{ dataEditGadai.diajukanOleh }}</b-col>
                    </b-row>
                </div>
            </b-form>

            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">APPROVAL EDIT GADAI</h6>
                <b-row class="mb-2">
                    <b-col cols="12" md="4" class="detail-data-label">Status Edit Gadai</b-col>
                    <b-col>{{ dataEditGadai.status }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="12" md="4" class="detail-data-label">Keterangan</b-col>
                    <b-col v-if="dataEditGadai.keteranganApproval != null">{{ dataEditGadai.keteranganApproval }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="12" md="4" class="detail-data-label">Diproses pada</b-col>
                    <b-col>{{ $helper.changeDateFormat(dataEditGadai.processedAt )}} {{ $helper.changeDateFormatGetHour(dataEditGadai.processedAt )}}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="12" md="4" class="detail-data-label">Diproses oleh</b-col>
                    <b-col>{{ dataEditGadai.processedBy }}</b-col>
                </b-row>
            </div>
        </b-card>
    </div>
</template>

<script>
import ModalFoto from '@/components/modals/ModalFoto'

export default {
    name: 'detail-daftar-edit-gadai',
    components: {
        ModalFoto,
    },
    data(){
        return{
            initStatus: 0,
            isSubmitting: false,
            keteranganApproval: "",
            approved: null,
            dataEditGadai: []
        }
    }, 

    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.id = this.$route.params.id
            
            let getDetailEditGadai = this.$axios.get(`daftar-edit-gadai/${this.id}`).then(response => {
                this.dataEditGadai = response.data
            })

            Promise.all([getDetailEditGadai]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },
    },

    created(){
        this.init()
    }
}
</script>
